import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { FooterContainer } from './FooterContainer';
export const FooterNav = React.forwardRef((props, ref) => (_jsx(FooterContainer, { ...props, component: 'nav', ref: ref })));
FooterNav.displayName = 'FooterNav';
